import { useSuspenseQuery } from '@tanstack/react-query';
import { airportsActivityGet } from '@/api/core/airports/airportsActivityGet';

export const useAirportsActivity = () => useSuspenseQuery({
    queryKey: ['airportsActivity'],
    queryFn: () => airportsActivityGet().then(r => r.payload).catch(() => [])
});
